import {
  FETCH_SERVICES_DELETION_LOGS_REQUEST,
  FETCH_SERVICES_DELETION_LOGS_SUCCESS,
  FETCH_SERVICES_DELETION_LOGS_FAILURE,
} from "./actionTypes";

const initialState = {
  logs: [],
  loading: false,
  error: null,
};

const servicesDeletionLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SERVICES_DELETION_LOGS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_SERVICES_DELETION_LOGS_SUCCESS:
      return { ...state, loading: false, logs: action.payload };
    case FETCH_SERVICES_DELETION_LOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default servicesDeletionLogsReducer;